{
  "name": "loyalty-admin-v3",
  "version": "2.100.0",
  "scripts": {
    "ng": "ng",
    "ng-with-env": "DOTENV_CONFIG_PATH=src/environments/.env.build.local node -r dotenv/config ./node_modules/.bin/ng",
    "start": "yarn generate:sprite && yarn ng-with-env serve --configuration=staging",
    "dev": "yarn generate:sprite && yarn ng-with-env serve --configuration=staging",
    "start:dev": "yarn generate:sprite && yarn ng-with-env serve --configuration=dev",
    "start:qa": "yarn generate:sprite && yarn ng-with-env serve --configuration=qa-01",
    "build": "yarn build:app",
    "build:local": "yarn ng-with-env build loyalty-admin-v3 --configuration=staging",
    "build:app": "yarn ng build loyalty-admin-v3 --configuration=staging",
    "build:app:fr": "yarn generate:sprite && BUILD_LOCALE=fr_FR BUILD_LANG=fr yarn ng build loyalty-admin-v3 --delete-output-path=false --deploy-url=https://cdn.wizbii.io/loyalty-admin-v3/$CI_COMMIT_SHA/fr/browser/",
    "format": "prettier --list-different --write --cache --cache-strategy metadata --cache-location './.prettiercache' '{src,esbuild,.storybook}/**/*.{ts,scss,json,yml,md,html}'",
    "lint": "concurrently --max-processes=50% \"yarn:lint:*\"",
    "lint:ts": "yarn ng lint",
    "eslint:ci": "yarn ng lint",
    "lint:pretty": "prettier --check --cache --cache-strategy metadata --cache-location './.prettiercache' '{src,esbuild,.storybook}/**/*.{ts,scss,json,yml,md,html}'",
    "//lint:ts-ignore-warnings": "Temporary ceiling for pre-existing ESLint-10 flat-config warnings (inherited from main). Acts as a ratchet: new warnings fail CI. Ratchet the number DOWN as warnings are fixed; target 0.",
    "lint:ts-ignore-warnings": "NODE_OPTIONS='--max-old-space-size=4096' yarn ng lint --max-warnings=390 --quiet",
    "prettier": "prettier --check --cache --cache-strategy metadata --cache-location './.prettiercache' '{src,esbuild,.storybook}/**/*.{ts,scss,json,yml,md,html}'",
    "prettier:ci": "prettier --check --cache --cache-strategy metadata --cache-location './.prettiercache' '{src,esbuild,.storybook}/**/*.{ts,scss,json,yml,md,html}'",
    "lint:scss": "stylelint --cache --cache-strategy metadata 'src/**/*.scss'",
    "stylelint:ci": "stylelint --cache --cache-strategy metadata 'src/**/*.scss'",
    "test": "jest --maxWorkers=50%",
    "test:ci": "yarn test --ci --coverage",
    "generate:sprite": "svg2sprite src/assets/icons  src/assets/sprites/icons.svg --iconPrefix=icons/",
    "release": "release-it --only-version",
    "postinstall": "husky",
    "find-deadcode": "knip",
    "unused-css": "ngx-unused-css > out 2>errors.txt || true",
    "storybook": "yarn generate:sprite && cp -r src/assets .storybook/public && yarn ng-with-env run loyalty-admin-v3:storybook",
    "build-storybook": "yarn generate:sprite && cp -r src/assets .storybook/public && yarn ng-with-env run loyalty-admin-v3:build-storybook"
  },
  "resolutions": {
    "webpack": "5.112.0"
  },
  "engines": {
    "node": "24"
  },
  "private": true,
  "prettier": "@loyalty/tooling/prettier-config",
  "dependencies": {
    "@angular/cdk": "~22.2.4",
    "@angular/common": "~22.2.3",
    "@angular/compiler": "~22.2.3",
    "@angular/core": "~22.2.3",
    "@angular/forms": "~22.2.3",
    "@angular/localize": "~22.2.3",
    "@angular/material": "~22.2.4",
    "@angular/platform-browser": "~22.2.3",
    "@angular/platform-browser-dynamic": "~22.2.3",
    "@angular/router": "~22.2.3",
    "@bugsnag/js": "^8.2.0",
    "@bugsnag/plugin-angular": "^8.2.0",
    "@ckeditor/ckeditor5-angular": "^9.1.0",
    "@ckeditor/ckeditor5-core": "^44.3.0",
    "@ckeditor/ckeditor5-engine": "^44.3.0",
    "@ckeditor/ckeditor5-utils": "^44.3.0",
    "@ckeditor/ckeditor5-watchdog": "^44.3.0",
    "@loyalty/utils": "^22.0.0",
    "@loyalty/utils-angular": "^22.0.0",
    "@ngrx/effects": "^22.0.1",
    "@ngrx/router-store": "^22.0.1",
    "@ngrx/store": "^22.0.1",
    "@ngrx/store-devtools": "^22.0.1",
    "@ngx-loading-bar/core": "~7.0.1",
    "@ngx-loading-bar/http-client": "~7.0.1",
    "@ngx-loading-bar/router": "~7.0.1",
    "@wizbii-components/angular-styles": "^5.18.1",
    "@wizbii-components/styles": "^5.18.1",
    "algoliasearch": "~5.51.0",
    "dayjs": "1.11.13",
    "event-source-polyfill": "~1.0.31",
    "ngx-color": "~10.1.0",
    "ngx-cookie-service": "^22.0.0",
    "ngx-image-cropper": "~8.1.1",
    "ngx-pipes": "~3.2.2",
    "ngx-skeleton-loader": "~12.0.0",
    "ngxtension": "^7.2.0",
    "rxjs": "~7.8.2",
    "type-fest": "~5.6.0",
    "uuid": "~13.0.0"
  },
  "devDependencies": {
    "@angular-builders/custom-esbuild": "~22.0.1",
    "@angular-devkit/architect": "~0.2202.4",
    "@angular-devkit/build-angular": "~22.2.4",
    "@angular-devkit/core": "~22.2.4",
    "@angular/animations": "~22.2.3",
    "@angular/build": "~22.2.4",
    "@angular/cli": "~22.2.4",
    "@angular/compiler-cli": "~22.2.3",
    "@compodoc/compodoc": "^1.2.1",
    "@jest/types": "^30.3.0",
    "@loyalty/node-utils": "^22.0.0",
    "@loyalty/tooling": "^22.0.0",
    "@storybook/addon-designs": "^12.0.0",
    "@storybook/addon-docs": "^10.6.3",
    "@storybook/addon-links": "^10.6.3",
    "@storybook/angular": "^10.6.3",
    "@types/deep-equal": "~1.0.4",
    "@types/event-source-polyfill": "~1.0.5",
    "@types/jest": "~30.0.0",
    "@types/node": "~24.10.15",
    "@types/uuid": "~11.0.0",
    "@wizbii/ngx-unused-css": "~4.0.2",
    "@wizbii/svg2sprite-cli": "~2.1.0",
    "ckeditor5": "~44.3.0",
    "commitlint": "~20.5.2",
    "concurrently": "^9.2.1",
    "deep-equal": "~2.2.3",
    "dotenv": "~17.4.2",
    "esbuild-plugin-environment": "^0.5.0",
    "eslint": "~10.6.0",
    "husky": "~9.1.7",
    "jest": "~30.3.0",
    "jest-date-mock": "~1.0.10",
    "jest-environment-jsdom": "^29.7.0",
    "jest-junit": "^16.0.0",
    "jest-preset-angular": "~17.0.3",
    "jest-sonar-reporter": "^2.0.0",
    "knip": "^5.88.1",
    "ng-mocks": "~14.18.4",
    "node-fetch": "~2.7.0",
    "prettier": "~3.8.3",
    "release-it": "~17.11.0",
    "storybook": "^10.6.3",
    "stylelint": "~17.9.1",
    "ts-jest": "^29.4.9",
    "typescript": "~6.0.3",
    "zone.js": "^0.16.1"
  },
  "packageManager": "yarn@4.17.1"
}
